import { render, staticRenderFns } from "./ArrangeEdit.vue?vue&type=template&id=48d498c2&scoped=true&"
import script from "./ArrangeEdit.vue?vue&type=script&lang=js&"
export * from "./ArrangeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ArrangeEdit.vue?vue&type=style&index=0&id=48d498c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d498c2",
  null
  
)

export default component.exports